<div class="login_part bodyclsss">
  <div class="container">
    <div class="d-flex justify-content-center h-100">
      <div class="card">
        <div class="row">
          <div class="offset-md-3 col-md-6 col-12 login_frm row">
            <div class="col-md-1"></div>
            <div class="logo col-md-12"><img src="./../../../assets/images/logo.png" style="height: auto;
              width: 180px;
              margin-top: -16px;
              margin-bottom: 14px;" alt="" /></div>
            <!-- <div class="logo col-md-8 text-left" style="color: #1a15ce; margin-bottom: 8px;"><h3 style="font-weight: 400;">Creative Energies Portal</h3></div> -->
            <div class="card-body col-8" style="border-top: solid 1px #dae0dd; border-right: solid 1px white;">
              <form
                name="login_frm"
                role="form"
                novalidate
                #form="ngForm"
                (ngSubmit)="submitForm()"
              >
                <div class="input-group form-group login_input2">
                  <!-- <div class="nurse_input leftpart ">
                    <input
                      type="radio"
                      id="whp1-option"
                      name="portaltype"
                      #portaltype="ngModel"
                      value="1"
                      [(ngModel)]="dataObj.portaltype"
                    />
                    <label for="whp1-option">Patient Portal </label>
                    <div class="check"></div>
                  </div>
                  <div class="nurse_input leftpart ">
                    <input
                      type="radio"
                      id="whp2-option"
                      name="portaltype"
                      [(ngModel)]="dataObj.portaltype"
                      #portaltype="ngModel"
                      value="2"
                    />
                    <label for="whp2-option">Enterprise Portal</label>
                    <div class="check"></div>
                  </div> -->
                  <div
                    class="input-group form-group login_input"
                    [ngClass]="{
                      'has-error':
                        (validation && userid.invalid) ||
                        (userid.invalid && (userid.dirty || userid.touched))
                    }"
                  >
                    <div class="input-group-prepend">
                      <span class="input-group-text"
                        ><i class="fas fa-user"></i
                      ></span>
                    </div>
                    <input
                      type="text"
                      style="font-size: 12px; background-color: #e8f0fe;"
                      class="form-control login_txt"
                      placeholder="Username / Email"
                      name="userid"
                      id="userid"
                      [(ngModel)]="dataObj.userid"
                      #userid="ngModel"
                      required="required"
                      autofocus="autofocus"
                      (blur)="removeSpaces()"
                    />
                    <div
                      class="help-block"
                      *ngIf="
                        (validation && userid.invalid) ||
                        (userid.errors && (userid.dirty || userid.touched))
                      "
                    >
                    
                      <p
                        *ngIf="
                          (validation && userid.errors.required) ||
                          userid.errors.required
                        "
                      >
                        Username cannot be empty.
                      </p>
                    </div>
                  </div>
                  <div
                    class="input-group form-group login_input"
                    [ngClass]="{
                      'has-error':
                        (validation && password.invalid) ||
                        (password.invalid &&
                          (password.dirty || password.touched))
                    }"
                  >
                    <div class="input-group-prepend">
                      <span class="input-group-text"
                        ><i class="fas fa-key"></i
                      ></span>
                    </div>
                    <input
                      type="password"
                      class="form-control login_txt input-field"
                      style="background-color: #e8f0fe;"
                      placeholder="password"
                      [(ngModel)]="dataObj.password"
                      #password="ngModel"
                      required="required"
                      name="password"
                      id="password"
                    />
                    <div
                      class="help-block"
                      *ngIf="
                        (validation && password.invalid) ||
                        (password.errors &&
                          (password.dirty || password.touched))
                      "
                    >
                      <p
                        *ngIf="
                          (validation && password.errors.required) ||
                          password.errors.required
                        "
                      >
                        Password cannot be empty.
                      </p>
                    </div>
                  </div>
                  <div class="d-flex justify-content-left" style="margin-bottom: 20px;">
                    <!-- <a [routerLink]="['/forgotpassword']">Forgot your password?</a> -->
                  </div>
                  <!-- <div class="d-flex justify-content-left remember">
                    <input type="checkbox" value="" /><label>Remember Me</label>
                  </div> -->
                  <div class="login_in_btn">
                    <!-- <input type="submit" value="Login" class="btn login_btn" /> -->
                    <button class="access-request-btn btn login_btn" style="font-size: 12px; padding: 7px;" type="submit">
                      <i class="fa fa-sign-in"></i>
                      Login</button>
                  </div>
                  

                  <div
                    *ngIf="error"
                    style="text-align: center;color:red;padding-top:20px;"
                  >
                  {{ errMessage }}
                </div>

                <div
                    *ngIf="success"
                    style="text-align: center;color:green;padding-top:20px;"
                  >
                  {{ successMessage }}
                </div>

                </div>
              </form>
            </div>

            <div class="btn_part col-4 text-left">
              Web based portal for your customers to view, search and download Bill of Ladings, Invoices, and load statuses in real-time. <span class="small">{{serverName}}</span>
              <!-- <h4>Don't have an account? </h4>
              <div class="login_in_btn">
                <button class="access-request-btn btn login_btn" style="font-size: 12px;" [routerLink]="['/signup']">
                  <i class="fa fa-cog" style="font-size: 12px;"></i>
                  Access Request</button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
